import React, {ReactNode} from "react";

export default function HFStepper({name, value, step, range, onChange, label, tips = null}: {
    name: string,
    value: number,
    step: number,
    range: [number, number],
    onChange: (name: string, value: number) => void,
    label: string,
    tips?: ReactNode,
}) {
    const onClick = (ev: React.MouseEvent<HTMLButtonElement>, positive: boolean) => {
        ev.preventDefault();

        let v = 0;

        if (positive) {
            if (value + step <= range[1]) {
                v = value + step;
            } else {
                v = range[1];
            }
        } else {
            if (value - step >= range[0]) {
                v = value - step;
            } else {
                v = range[0];
            }
        }

        onChange(name, v);
    }

    return (
        <div className="labeled-input">
            <div className="label-group">
                <label htmlFor={name} className="label">{label}</label>
                <div className="tips">{tips}</div>
            </div>

            <div className="input stepper">
                <button onClick={(ev) => onClick(ev, false)}>-</button>
                <div>{value}</div>
                <button onClick={(ev) => onClick(ev, true)}>+</button>
            </div>
        </div>
    );
}